var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5 0C34.3177 0 0 34.3177 0 76.5C0 118.682 34.3177 153 76.5 153C118.682 153 153 118.682 153 76.5C153 34.3177 118.682 0 76.5 0ZM76.5 144.247C39.1437 144.247 8.75253 113.856 8.75253 76.5C8.75253 39.1442 39.1437 8.75253 76.5 8.75253C113.856 8.75253 144.247 39.1442 144.247 76.5C144.247 113.856 113.856 144.247 76.5 144.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.218 34.9868H83.8443C75.3539 34.9868 68.4462 41.8945 68.4462 50.3849V62.055H58.782C56.3648 62.055 54.4057 64.0141 54.4057 66.4312C54.4057 68.8484 56.3648 70.8075 58.782 70.8075H68.4462V111.328C68.4462 113.745 70.4053 115.705 72.8225 115.705C75.2396 115.705 77.1987 113.745 77.1987 111.328V70.8075H92.151C94.5681 70.8075 96.5272 68.8484 96.5272 66.4312C96.5272 64.0141 94.5681 62.055 92.151 62.055H77.1987V50.3849C77.1987 46.7206 80.1799 43.7393 83.8443 43.7393H94.2175C96.6347 43.7393 98.5938 41.7802 98.5938 39.3631C98.5938 36.9459 96.6347 34.9868 94.218 34.9868Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 153,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.0b99566a6ad880b72f8a17bd53893054.svg";
export { ForwardRef as ReactComponent };